import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { OneClickUpdateOrderAction } from '../../actions/one-click-orders.actions';
import { State } from '../../reducers';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { getOneClickPaymentsAt } from '../../selectors/one-click-payments.selector';

@Injectable()
export class OneClickSetPayment implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: number, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getOneClickPaymentsAt(form.mapItem['index']))
        .pipe(
          filter((payments) => !!payments.length),
          take(1),
          map((payments) => payments.find((item) => item.paymentTermId === value)),
          switchMap((payment) =>
            this.store.select(getOneClickSelectedOrder).pipe(
              take(1),
              map((order) => ({ order, payment })),
            ),
          ),
        )
        .subscribe(({ order, payment }) => {
          const modded: Order = {
            ...order,
            items: order.items.map((item, index) => {
              if (index === form.mapItem['index']) {
                return { ...item, paymentTerm: payment };
              } else {
                return item;
              }
            }),
          };

          this.store.dispatch(new OneClickUpdateOrderAction(modded));
        });
    }
  }
}
